import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "./httpclient.service";

@Injectable()
export class PreferenceService {
	constructor(private httpclientService: HttpclientService) {}

	preferenceList(category, keyName, schoolID, personID) {
		var postResult$ = new Subject();
		var url = "Preference/GetPreference?category=" + category + "&keyName=" + keyName + "&schoolID=" + schoolID + "&personID=" + personID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	setPreference(preference) {
		var postResult$ = new Subject();
		var url = "Preference/SetPreference";

		var promise$ = this.httpclientService.post(url, preference);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
